export function filterImages(images:[], value: string) {
  return images?.filter((image) => image[value] !== 'On model')
}

export function pickFirstImage(images:[], value: string) {
  return images?.filter((image) => image[value] !== 'On model')[0]
}
